var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"total_compensation":_vm.total_compensation,"total_clients":_vm.total_clients,"average_saved":_vm.average_saved,"reviews":_vm.reviews,"score":_vm.score}})}
var staticRenderFns = []

export { render, staticRenderFns }